import React, { useEffect, Fragment } from "react"
import {
  SearchContainer,
  FlatItemContainer,
} from "./searchStyles"
import { Col, Container, Row, Accordion } from "react-bootstrap"


import flats from "../../flats/flatList/ogw2_e3B_Array"
import posed, { PoseGroup } from "react-pose"
import { MobileButton } from "../shared/button/button"
import ModalComponent from "../shared/modal/modal"
import ShowMore from "@tedconf/react-show-more"
import { injectIntl } from "gatsby-plugin-intl"
import { Link as Scroller } from "react-scroll"
import { Button } from "react-bootstrap"
import SearchHistoryButton from "@/components/search/searchHistoryButton"

const PoseWrapper = posed.div({
  enter: { opacity: 1, delay: ({ i }) => i * 100 },
  exit: { opacity: 0, delay: 50 },
})
function Search({ estate, searchParams, intl }) {
  const list = flats

  const gtag_report_ask_conversion = () => {
    if (window.gtag_report_ask_conversion) {
      window.gtag_report_ask_conversion()
    }
  }
  const addID = item => {
    return localStorage.setItem("id", item)
  }

  return (
    <Container className="flats">
      <SearchContainer>
        {/* DESKTOP VIEW ***************************************** */}
        <Row className="desktop-container">
          <Col xs="12" className="no-padding desktop-list-title">
            <h1 className="no-padding">
              {intl.formatMessage({
                id: "offer.janowo.list.title",
              })}
            </h1>
          </Col>
        </Row>


        {/* MOBILE VIEW ************************ */}

          <Row className="mobile-container">
            <Col xs="12" className="no-padding desktop-list-title">
              <h1 className="no-padding">
                {intl.formatMessage({
                  id: "offer.janowo.list.title",
                })}
              </h1>
            </Col>
          </Row>


        <div className="container-border">
          <h2>
            {intl.formatMessage({id: "offer.janowo.list.results.number.all"})}
          </h2>

            <Row className="legend-info wicz">
              <Col >
                Budynek
              </Col>
              <Col >
                Numer lokalu
              </Col>

              <Col >
                Powierzchnia
              </Col>
              <Col >
                {intl.formatMessage({
                  id: "offer.janowo.list.results.space2",
                })}
              </Col>
              <Col
               xs={2}
                style={{
                  lineHeight: 1,
                }}
              >
                Planowany termin odbioru
              </Col>
              <Col xs="4">
                <Row style={{ padding: 0 }} className={"text-center"}>

                  <Col style={{ padding: 0 }}>PDF</Col>
                  <Col style={{ padding: 0 }}>CENA <small className="d-block">(brutto)</small></Col>
                  <Col style={{ padding: 0 }}>ZAPYTAJ</Col>
                </Row>
              </Col>
            </Row>
          <div
            style={{
              height: list.length < 1 && "0",
              overflow: "hidden",
              marginBottom: "50px",
            }}
          >
            {list.length > 0 ? (
              <PoseGroup>
                <ShowMore items={list} by={30} key="1">
                  {({ current, onMore }) => (
                    <Fragment>
                      {current.map((item, i) => (
                        <PoseWrapper key={i} i={i}>
                          <FlatItemContainer>
                            <Fragment>
                              <Accordion
                                className={`${!item.sold ? "" : "sold"}`}
                                defaultActiveKey=""
                              >
                                <div>
                                  <Accordion.Toggle as={"div"} eventKey="0">
                                    <div className={`mobile-results `}>
                                      <Col
                                        xs="12"
                                        className="main-results no-padding"
                                      >
                                        <div className="results-item ">
                                          {item.building}/{item.number}
                                        </div>

                                        <div className="results-item">
                                          <small style={{marginRight: '0.5em'}}>Powierzchnia:</small>
                                          {item.history[0].size}m<sup>2</sup>
                                        </div>
                                        <div className="results-item id-item">
                                          {item.pow_d}m<sup>2</sup>
                                        </div>
                                      </Col>
                                    </div>

                                    <div
                                      className={`desktop-results ${
                                        !item.sold ? "" : "sold"
                                      }`}
                                    >
                                      <Row>
                                        <Col

                                          className="no-padding table-result-item"
                                        >
                                          <div className="results-item  id-item">
                                            {item.building}
                                          </div>
                                        </Col>
                                        <Col

                                          className="no-padding table-result-item"
                                        >
                                          <div className="results-item  id-item">
                                            {item.number}
                                          </div>
                                        </Col>
                                        <Col

                                          className="table-result-item"
                                        >
                                          <div className="results-item ">
                                            {item.history[0].size}m<sup>2</sup>
                                          </div>
                                        </Col>


                                        <Col
                                          className="table-result-item"

                                        >
                                          <div className="results-item ">
                                            {item.pow_d}m<sup>2</sup>
                                          </div>
                                        </Col>


                                        <Col
                                          className="no-padding date-mobile table-result-item"
                                          xs={2}
                                        >
                                          <div className="results-item  date">
                                            <span></span>{" "}
                                            {item.date}
                                          </div>
                                        </Col>
                                        <Col
                                          className="no-padding table-result-item"
                                          xs={4}
                                        >
                                          {/* Options */}
                                          <Row className="text-center results-item details options">
                                            {/* Spacer 3d */}
                                            {/*<Col >

                                              item.tour ? (
                                                <ModalComponent
                                                  className={"full-modal"}
                                                >
                                                  <MobileButton
                                                    handleAction={() => {
                                                      // setActiveTour(i)
                                                    }}
                                                    bg="#eaeaea"
                                                    border="transparent"
                                                    arrow={false}
                                                    smallArrow={false}
                                                  >
                                                    Spacer 3d
                                                  </MobileButton>
                                                  <iframe
                                                    src={item.tour}
                                                    width={"100%"}
                                                    height={
                                                      typeof window !==
                                                      "undefined"
                                                        ? `${window.innerHeight *
                                                        0.9}px`
                                                        : "100%"
                                                    }
                                                  />
                                                </ModalComponent>
                                              ) : (
                                                <MobileButton
                                                  bg="#eee"
                                                  color="black"
                                                  border="transparent"
                                                  arrow={false}
                                                  smallArrow={false}
                                                  disabled
                                                >
                                                  Spacer 3d
                                                </MobileButton>
                                              )
                                            </Col>*/}
                                            <Col>
                                              {/* Karta lokalu */}
                                              {item.pdf ? (
                                              <a
                                                className="results-item"
                                                href={item[11]}
                                                target={"_blank"}
                                                rel="noopener noreferrer"

                                              >
                                                <MobileButton
                                                  handleAction={() => item}
                                                  innerText={intl.formatMessage(
                                                    {
                                                      id:
                                                        "offer.janowo.list.options.card",
                                                    }
                                                  )}
                                                  bg="#5D5D5D"
                                                  color="white"
                                                  border="transparent"
                                                  arrow={false}
                                                  smallArrow={false}
                                                />
                                              </a>
                                              ): (
                                                <MobileButton
                                                  bg="#eee"
                                                  color="black"
                                                  border="transparent"
                                                  arrow={false}
                                                  smallArrow={false}
                                                  disabled
                                                >
                                                  {intl.formatMessage(
                                                    {
                                                      id:
                                                        "offer.janowo.list.options.card",
                                                    }
                                                  )}
                                                </MobileButton>
                                              )}
                                            </Col>
                                            <Col>
                                              {/* Cena */}

                                              <SearchHistoryButton
                                                price={item.history[0].price}
                                                m2={item.history[0].m2}
                                                sold={item.sold}
                                                history={item.history}
                                                netto={item.netto}
                                              />
                                            </Col>
                                            <Col>
                                              {/* Zapytaj */}
                                              <MobileButton
                                                handleAction={() => {
                                                  document.getElementById(
                                                    "myModal"
                                                  ).style = {
                                                    display: "block",
                                                  }
                                                  document.getElementsByClassName(
                                                    "code"
                                                  )[0].innerText = item.id
                                                  document.getElementById(
                                                    "projectName"
                                                  ).value = estate
                                                  gtag_report_ask_conversion()
                                                }}
                                                bg={
                                                  item.sold
                                                    ? "#dadada"
                                                    :  "#94C835"
                                                }
                                                color={
                                                  !item.sold
                                                    ? "white"
                                                    : "black"
                                                }
                                                border={"transparent"}
                                                arrow={false}
                                                smallArrow={false}
                                              >
                                                {!item.sold ? (
                                                  `Zapytaj`
                                                ) : (
                                                  <>
                                                    Sprzedane
                                                  </>
                                                )}
                                              </MobileButton>
                                            </Col>
                                          </Row>


                                        </Col>
                                      </Row>
                                    </div>
                                  </Accordion.Toggle>
                                  <div className={"mobile-only"}>
                                    <Accordion.Collapse eventKey="0">
                                      <Row>
                                        <Col
                                          className="no-padding date-desktop"
                                          xs="12"
                                        >
                                          <div className="results-item date">
                                            <span></span>{" "}
                                            {!item.sold && item.date}
                                          </div>
                                        </Col>
                                        <Col
                                          xs="0"
                                          sm="0"
                                          md="0"
                                          // lg={item[13] === "" ? "6" : "8"}
                                          lg={"2"}
                                          xl="4"
                                          className="btns-offset"
                                        ></Col>
                                        <Col
                                          className="no-padding options-btn"
                                          xs="12"
                                          sm="12"
                                          md="12"
                                          lg="3"
                                          xl="2"
                                        >
                                          {item.tour && (
                                            <div className="results-item">
                                              <ModalComponent
                                                className={"full-modal"}
                                              >
                                                <MobileButton
                                                  handleAction={() => {
                                                    // setActiveTour(i)
                                                  }}
                                                  innerText={intl.formatMessage(
                                                    {
                                                      id:
                                                        "offer.janowo.list.options.tour",
                                                    }
                                                  )}
                                                  bg="#eaeaea"
                                                  border="#eaeaea"
                                                  arrow={true}
                                                  smallArrow={true}
                                                />
                                                <iframe
                                                  src={item.tour}
                                                  width={"100%"}
                                                  height={
                                                    typeof window !==
                                                    "undefined"
                                                      ? `${window.innerHeight *
                                                      0.9}px`
                                                      : "100%"
                                                  }
                                                />
                                              </ModalComponent>
                                            </div>
                                          )}
                                        </Col>
                                        <Col
                                          className="no-padding options-btn"
                                          xs="12"
                                          sm="12"
                                          md="12"
                                          lg="3"
                                          xl="2"
                                        >
                                          <div
                                            className="results-item"
                                            // href={"budynek"}
                                          >
                                            <Scroller
                                              activeClass="active"
                                              to={"localization"}
                                              spy={true}
                                              smooth={true}
                                              offset={50}
                                              duration={500}
                                            >
                                              <MobileButton
                                                handleAction={() => item}
                                                innerText={intl.formatMessage({
                                                  id:
                                                    "offer.janowo.list.options.localization",
                                                })}
                                                bg="#DADADA"
                                                border="#DADADA"
                                                arrow={true}
                                                smallArrow={true}
                                              />
                                            </Scroller>
                                          </div>
                                        </Col>
                                        <Col
                                          className="no-padding options-btn"
                                          xs="12"
                                          sm="12"
                                          md="12"
                                          lg="3"
                                          xl="2"
                                        >
                                          { item.pdf && (
                                          <a
                                            className="results-item"
                                            href={item.pdf}
                                            target={"_blank"}
                                            rel="noopener noreferrer"
                                          >
                                            <MobileButton
                                              handleAction={() => item}
                                              innerText={intl.formatMessage({
                                                id:
                                                  "offer.janowo.list.options.card",
                                              })}
                                              bg="#5D5D5D"
                                              color="white"
                                              border="#5D5D5D"
                                              arrow={true}
                                              smallArrow={true}
                                            />
                                          </a>
                                          )}
                                        </Col>
                                        <Col
                                          className={`mobile-results mobile-results-button no-padding options-btn ${
                                            !item.sold ? "" : "sold"
                                          }`}
                                          xs="12"
                                          sm="12"
                                          md="12"
                                          lg="3"
                                          xl="2"
                                        >
                                          <div
                                            className="results-item"
                                            onClick={() => addID(item.id)}
                                          >

                                            <SearchHistoryButton
                                              price={item.price}
                                              m2={item.m2}
                                              sold={item.sold}
                                              history={item.history}
                                              netto={item.netto}
                                            />

                                            <MobileButton
                                              handleAction={() => {
                                                document.getElementById(
                                                  "myModal"
                                                ).style = { display: "block" }
                                                document.getElementsByClassName(
                                                  "code"
                                                )[0].innerText = item.id
                                                document.getElementById(
                                                  "projectName"
                                                ).value = estate
                                                gtag_report_ask_conversion()
                                              }}
                                              bg={
                                                item.sold
                                                  ? "transparent"
                                                  :  "#94C835"
                                              }
                                              color={
                                                !item.sold
                                                  ? "white"
                                                  : "black"
                                              }
                                              arrow={true}
                                              border={!item.sold
                                                ? "transparent"
                                                : "grey"}
                                              smallArrow={true}
                                              className={"price"}
                                            >
                                              {
                                                intl.formatMessage({
                                                  id:
                                                    "offer.janowo.list.options.askForPrice",
                                                })
                                              }
                                            </MobileButton>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Accordion.Collapse>
                                  </div>
                                </div>
                              </Accordion>
                            </Fragment>
                          </FlatItemContainer>
                        </PoseWrapper>
                      ))}

                      {onMore ? (
                        <Row>
                          <Col className="no-padding show-more" xs="12">
                            <MobileButton
                              innerText={intl.formatMessage({
                                id: "offer.janowo.list.results.more",
                              })}
                              bg="#94C835"
                              color="white"
                              border="#94C835"
                              arrow={false}
                              disabled={!onMore}
                              handleAction={() => {
                                if (!!onMore) onMore()
                              }}
                            />
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                    </Fragment>
                  )}
                </ShowMore>
              </PoseGroup>
            ) : (
              <div key="brak"></div>
            )}
          </div>

        </div>
        <Row>
          {list && list.length < 1 && (
            <Col xs="12" className="no-results">
              <div>
                <Fragment></Fragment>
              </div>
            </Col>
          )}
        </Row>
      </SearchContainer>
    </Container>
  )
}

export function SearchButtonWrapper({
  item,
  addValue,
  num,
  reset,
  setActiveFilters,
  activeFilters,
  activeFiltersCounter,
  setActiveFiltersCounter,
}) {
  useEffect(() => {}, [reset])

  return (
    <Button
      className={
        activeFilters.hasOwnProperty(item.value)
          ? `search-filter active ${item.label}`
          : `search-filter ${item.label}`
      }
      variant={false}
      disabled={false}
      onClick={e => {
        addValue(e, num, item.value, item.id)
        setActiveFiltersCounter(
          e.target.className.includes("active")
            ? (activeFiltersCounter -= 1)
            : (activeFiltersCounter += 1)
        )
        setActiveFilters(
          activeFilters && activeFilters.hasOwnProperty(item.value)
            ? () => {
                delete activeFilters[item.value]
                return activeFilters
              }
            : { ...activeFilters, [item.value]: item.value }
        )
      }}
      data-cat={item.id}
    >
      {item.label}
    </Button>
  )
}

export default injectIntl(Search)
